<template>
    <div>
        <h3>PROFIL</h3>
        <h5>Uzytkownik: <span>{{userData.name}}</span></h5>
        <div><b-button class="backButton" v-on:click="togglePasswordChange">ZMIANA HASŁA</b-button></div>
        <PasswordChange v-if="showPasswordChange" v-bind:userData="userData" v-on:cancelProfile="togglePasswordChange"/>
        <div><b-button class="backButton" v-on:click="toggleTemplates">EDYCJA SZABLONÓW</b-button></div>
        <TemplatesCMS v-if="showTemplates" :key="templatesKey" v-bind:userData="userData" v-bind:dbTemplates="templates" v-on:shutMessages="closeTemplates"/>
        <div v-if="templateAdded">{{information}}</div>
        <div><b-button class="backButton" v-on:click="toggleTargetGroups">EDYCJA GRUP DOCELOWYCH</b-button></div>
        <TargetGroupCMS v-show="showTargetGroups" :key="groupsKey" v-bind:dbGroups="groups" v-bind:dbUsers="groupUsers" v-bind:userData="userData" v-on:shutGroups="closeGroups"/>
        <div v-if="groupAdded">{{information}}</div>
        <div><b-button class="backButton" v-on:click="returnToMainApp">WRÓĆ</b-button></div>
    </div>
</template>

<script>
import PasswordChange from './MainComponents/PasswordChange';
import axios from 'axios';
import{path} from '../../config'
import TemplatesCMS from './CMScomponents/TemplatesCMS';
import TargetGroupCMS from './CMScomponents/TargetGroupCMS';
export default {
    name: "Profile",
    components: {
        PasswordChange,
        TemplatesCMS,
        TargetGroupCMS
    },
    props: {
        userData: Object,
    },
    methods: {
        returnToMainApp: function() {
            this.$emit('returnFromCMS')
        },
        togglePasswordChange: function() {
            this.showPasswordChange = !this.showPasswordChange;
        },
        toggleTemplates: async function() {
            await axios
            .get(`${path}templates`)
            .then(response => (
                this.filterTemplates(response.data)
            ))
            .catch(e => (
                console.log(e)
            ))
            await this.rerender();
            this.showTemplates = !this.showTemplates;
            this.templateAdded = false;
        },
        filterTemplates: function(templates){
            this.templates = [];
            for(let item of templates){
                if(item.author === this.userData.name){
                    this.templates.push(item)
                }
            }
        },
        toggleTargetGroups: async function() {
            await axios
            .get(`${path}groups`)
            .then(response => (
                this.filterGroups(response.data)
                // this.groups = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            await axios
            .get(`${path}users`)
            .then(response => (
                this.groupUsers = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            await this.rerender();
            this.showTargetGroups = !this.showTargetGroups;
            this.groupAdded = false;
        },
        filterGroups: function(groups){
            this.groups = [];
            for(let item of groups){
                if(item.author === this.userData.name){
                    this.groups.push(item)
                }
            }
        },
        closeTemplates: function(info) {
            this.showTemplates = false;
            this.information = info;
            this.templateAdded = true;
        },
        closeGroups: function(info) {
            this.showTargetGroups = false;
            this.information = info;
            this.groupAdded = true;
        },
        rerender: function() {
            this.templatesKey += 1;
            this.levelsKey += 1;
            this.groupsKey += 1;
            this.usersKey += 1;
            this.loginsKey += 1;
        },

    },
    data: function() {
        return{
            showPasswordChange: false,
            showTemplates: false,
            showTargetGroups : false,
            templates: [],
            information: '',
            groups: '',
            groupUsers: '',
            templateAdded: false,
            groupAdded: false,
            groupsKey: 1,
            templatesKey: 2,
        }
    }
}
</script>

<style lang="scss" scoped>
    .backButton {
        height: 50px;
        width: 90%;
        font-size: 20px;
        background-color: blue;
        border-radius: 10px;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(40, 110, 214);
        }
        &:focus{
            background-color: blue;
            border: none;
            box-shadow: none;
        }
    }
</style>